import React from 'react';

function CircleArrowDown(props: object) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="13"
        cy="13"
        r="12.5"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0)"
        stroke="currentColor"
      />
      <path
        d="M18.2807 10.9414L13.934 15.2881C13.4207 15.8014 12.5807 15.8014 12.0674 15.2881L7.7207 10.9414"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CircleArrowDown;
